import { useCallback, useEffect, useMemo, useState } from "react";
import { AxiosRequest } from "_services/api";
import { HttpError } from "_services/api/HttpError";
import { HttpResponse } from "_services/api/HttpResponse";
import {
  IData,
  IHttpError,
  IHttpResponse,
} from "_services/api/interface/HttpResponse";

export function useCentroCusto(empresa: any, centroCusto: any) {
  const [centrosCustoOptions, setCentrosCustoOptions] = useState<any[]>([]);
  const [solicitantesOptions, setSolicitantesOptions] = useState<any[]>([]);
  const [error, setError] = useState<IHttpResponse<IData | any>>();

  const api = useMemo(() => AxiosRequest.makeApi(process.env.REACT_APP_MS_AW), []);

  const listar = useCallback(
    async (empresa: any) => {
      try {
        const { status, data } = await api.get(
          `/centro_custo/empresa/${empresa}`
        );
        const response = new HttpResponse(false, status, data);
        setError(response);
        criarOptionsCentrosCusto(data);
        return response;
      } catch (error: IHttpError<IData, any> | any) {
        criarOptionsCentrosCusto([]);
        const response = new HttpError<IData>(true, error);
        setError(response);
        return response;
      }
    },
    [api]
  );

  const listarSolicitantesComRepresentante = useCallback(
    async (centroCusto: any) => {
      try {
        const { status, data } = await api.get(
          `/solicitante_centro_custo/centro/${centroCusto}/representante`
        );
        const response = new HttpResponse(false, status, data);
        setError(response);
        criarOptionsSolicitantes(data);
        return response;
      } catch (error: IHttpError<IData, any> | any) {
        criarOptionsSolicitantes([]);
        const response = new HttpError<IData>(true, error);
        setError(response);
        return response;
      }
    },
    [api]
  );

  useEffect(() => {
    if (!empresa) {
      setCentrosCustoOptions([]);
      setSolicitantesOptions([]);
      return;
    }

    listar(empresa);
  }, [listar, empresa]);

  useEffect(() => {
    if (!centroCusto) {
      setSolicitantesOptions([]);
      return;
    }

    listarSolicitantesComRepresentante(centroCusto);
  }, [listarSolicitantesComRepresentante, centroCusto]);

  function criarOptionsCentrosCusto(CentrosCusto: any[]) {
    const optionsCentrosCusto = CentrosCusto.map((item) => ({
      value: item.id,
      label: item.nome,
    }));

    setCentrosCustoOptions(optionsCentrosCusto);
  }

  function criarOptionsSolicitantes(Solicitantes: any[]) {
    const optionsSolicitantes = Solicitantes.map((item) => ({
      value: item.id,
      label: item.nome,
    }));

    setSolicitantesOptions(optionsSolicitantes);
  }

  return {
    centrosCustoOptions,
    solicitantesOptions,
  };
}
